import Graph from '@/components/common/Icons/courseDescription/Graph';
import Partner from '@/components/common/Icons/courseDescription/Partner';
import Presentation from '@/components/common/Icons/courseDescription/Presentation';
import Rocket from '@/components/common/Icons/courseDescription/Rocket';
import CourseDescriptionContext from '@/context/CourseDescriptionContext';
import { Card, Typography } from '@pwskills/rachnaui';
import React, { useContext } from 'react';

const PlacementStatistics = () => {
  const { courseDetails } = useContext(CourseDescriptionContext);
  const { statsInfo } = courseDetails?.courseMetaDetails || {};
  const { careerTransitions, highestSalary, averageSalaryHike, hiringPartner } = statsInfo || {};

  return (
    <div className="flex flex-wrap medium:!flex-nowrap gap-x-4 large:!gap-x-[96px] items-center justify-center">
      <Card className="flex flex-col items-center justify-center gap-y-3 py-6 !shadow-none !m-0 min-w-[156px]  medium:!w-[158px] large:!w-auto">
        <Rocket />
        <div className="text-center">
          <Typography component="h4" variant="bold" className="text-gray-850">
            {highestSalary}
          </Typography>
          <Typography component="body-regular" variant="regular" className="text-gray-850">
            Highest Package
          </Typography>
        </div>
      </Card>
      <Card className="flex flex-col items-center justify-center gap-y-3 py-6 !shadow-none  !m-0 min-w-[156px]  medium:!w-[158px] large:!w-auto">
        <Presentation />
        <div className="text-center">
          <Typography component="h4" variant="bold" className="text-gray-850">
            {careerTransitions}
          </Typography>
          <Typography component="body-regular" variant="regular" className="text-gray-850">
            Learners Placed
          </Typography>
        </div>
      </Card>
      <Card className="flex flex-col items-center justify-center gap-y-3 py-6 !shadow-none !m-0 min-w-[156px]  medium:!w-[158px] large:!w-auto">
        <Graph />
        <div className="text-center">
          <Typography component="h4" variant="bold" className="text-gray-850">
            {averageSalaryHike}
          </Typography>
          <Typography component="body-regular" variant="regular" className="text-gray-850">
            Average Salary
          </Typography>
        </div>
      </Card>
      <Card className="flex flex-col items-center justify-center gap-y-3 py-6 !shadow-none !m-0 min-w-[156px]  medium:!w-[158px] large:!w-auto">
        <Partner />
        <div className="text-center">
          <Typography component="h4" variant="bold" className="text-gray-850">
            {hiringPartner}
          </Typography>
          <Typography component="body-regular" variant="regular" className="text-gray-850">
            Hiring Partners
          </Typography>
        </div>
      </Card>
    </div>
  );
};

export default PlacementStatistics;
